"use client"

import { Button, Card, Col, Divider, message, Row, Skeleton, theme } from "antd"
import { Voucher } from "@/lib/redux/features/voucher/type"
import { FC } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendarAlt, faCopy, faHotel, faPlaneCircleCheck, faPlaneSlash, faTicketAlt } from "@fortawesome/free-solid-svg-icons"
import Text from "@/components/common/Typography/Text"
import { useTranslation } from "react-i18next"
import { getValidDayjs } from "@/utils/safeParse/getValidDayjs"
import { useTERouter } from "@/hooks/app/useTERouter"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import _ from "lodash"
import { toast } from "react-toastify"

type PromotionItemSkeletonProps = {
}

const PromotionItemSkeleton: FC<PromotionItemSkeletonProps> = ({  }) => {

  return (
    <Card
      size='small'
      hoverable
    >
      <Row gutter={[15, 15]}>
        <Col>
          <Skeleton
            paragraph={false}
            styles={{
              title: {
                height: '2.5rem',
                width: '2.5rem',
                margin: 0
              }
            }}
            active
          />
        </Col>
        <Col flex={1}>
          <Row>
            <Skeleton
            paragraph={false}
            styles={{
              title: {
                height: '2.5rem',
                width: '100%',
                margin: 0
              }
            }}
            active
          />
          </Row>
        </Col>
      </Row>
      <Divider style={{ marginBlock: 10 }} dashed />
      <Row gutter={[10, 10]}>
        <Col
          flex={1}
        >
          <Skeleton
            paragraph={false}
            styles={{
              title: {
                height: '3.2rem',
                width: '100%',
                margin: 0
              }
            }}
            active
          />
        </Col>
        <Col>
          <Skeleton
            paragraph={false}
            styles={{
              title: {
                height: '3.2rem',
                width: '8rem',
                margin: 0
              }
            }}
            active
          />
        </Col>
      </Row>
      <Row style={{ marginTop: '0.5rem' }}>
        <Skeleton
            paragraph={false}
            styles={{
              title: {
                height: '2.2rem',
                width: '16rem',
                margin: 0
              }
            }}
            active
          />
      </Row>
    </Card>
  )
}

export default PromotionItemSkeleton